/**
 * Id gerado no navegador para cada mensagem enviada. Vai no POST e é
 * reaproveitado nas retentativas: a API devolve a mensagem que já existe em
 * vez de gravar outra (Enter duplo, reenvio depois de timeout, etc.).
 */
export function newClientMessageId(): string {
  const c: any = typeof crypto !== 'undefined' ? crypto : undefined
  if (c?.randomUUID) return c.randomUUID()
  const bytes = new Uint8Array(16)
  if (c?.getRandomValues) c.getRandomValues(bytes)
  else for (let i = 0; i < 16; i++) bytes[i] = Math.floor(Math.random() * 256)
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
}
